// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slide-enter-active[data-v-d5e85e8c]{transition-duration:.2s;transition-timing-function:ease}.slide-leave-active[data-v-d5e85e8c]{transition-duration:.2s;transition-timing-function:cubic-bezier(0,1,.5,1)}.slide-enter-to[data-v-d5e85e8c],.slide-leave[data-v-d5e85e8c]{max-height:100px;overflow:hidden}.slide-enter[data-v-d5e85e8c],.slide-leave-to[data-v-d5e85e8c]{overflow:hidden;max-height:0}", ""]);
// Exports
module.exports = exports;
